function logToConsole(type = "log", ...message) {
  // eslint-disable-next-line no-console
  console[type]("\nanalytics: ", ...message, "\n")
}

export default logToConsole
